import { Map } from 'immutable'
import React from 'react'
import { Action, any, AsyncState, loadingAsyncState, async, Option, none, some, onlyIf, wait, unloadedAsyncState, IOWidget } from 'widgets-for-react'
import { fromJSX, SimpelPageMap } from '../../../../utils'
import { getParameterByName } from '../../../cms/blocks/utils.gen'
import { FormState } from '../../../form/types'
import { WordPress } from '../../../wordpress/wordpress_api'
import { BrochuresWebshopLayout } from './brochuresWebshop.Layout'
import { ShoppingCart } from './brochureWebshop.types'
import { setBrochureWebShopState } from './brochureWebShop.utils'
import { BrochuresBlockProps } from '../../blocks/custom_blocks/widgets/brochuresBlock'

export interface BrochureWebshopState {
    brochures: Map<number, AsyncState<SimpelPageMap<string, WordPress.BrochureResponse>>>
    terms: AsyncState<WordPress.TaxonomyResponse[]>
    shopping_cart: ShoppingCart,
    size: number
    total_pages: Option<number>
    total_items: number
    current_page: number
    selected_term: Option<number>
    step: 'step 1 - catalog' | 'step - 2 - form'
    form: FormState
    country: number
    country_name: string
}

// You can lower this to for testing with less data, default should be 9
const PAGE_SIZE = 9

export const zeroWebshopState: BrochureWebshopState = {
    brochures: Map(),
    terms: loadingAsyncState(() => WordPress.api<WordPress.TaxonomyResponse>()
      .where({ per_page: 99 })
      .terms('brochures_taxonomy').then(d => {
        if (d.status != 200) return ({ kind: 'failed', status: d.status })
        return ({ kind: 'result', status: d.status, value: d.data })
    })),
    shopping_cart: Map(),
    size: PAGE_SIZE,
    total_pages: none(),
    total_items: 0,
    current_page: 1,
    selected_term: none(),
    step: 'step 1 - catalog',
    form: {
        context: { external_options: Map() },
        dependencies_state: Map(),
        form_data: unloadedAsyncState(),
        form_submission_logic: unloadedAsyncState(),
    },
    country: 0,
    country_name: ''
}

export const brochuresWidget : IOWidget<BrochuresBlockProps, Action<BrochureWebshopState>> = (s0) => {
  return(
    any<Action<BrochureWebshopState>>()([
      wait<Action<BrochureWebshopState>>(100)((() => s1 => {
        return ({
            ...s1,
            country: s0.country,
            country_name: s0.country_name
        })
      })),
      onlyIf(s0.state.total_pages.v.kind == 'l' || s0.state.brochures.count() < s0.state.total_pages.v.v,
        wait<Action<BrochureWebshopState>>(1000)(() => s1 => {
          let has_next = s1.total_pages.v.kind == 'l' || (s1.brochures.count() < s1.total_pages.v.v)
          if (!has_next) return s1 

          return setBrochureWebShopState('current_page', s1.current_page)(s1)
        })
        ),

        onlyIf(s0.state.shopping_cart.count() == 0 && sessionStorage.getItem('shoppingcart') != null, wait<Action<BrochureWebshopState>>(100)((() => s1 => {
            return ({
                ...s1,
                shopping_cart: Map(JSON.parse(sessionStorage.getItem('shoppingcart')))
            })
        }))),

        onlyIf(getParameterByName('term') != '' && s0.state.selected_term.v.kind == 'l' && !isNaN(Number(getParameterByName('term'))), wait<Action<BrochureWebshopState>>(100)(() => s1 => ({ ...s1, selected_term: some(Number(getParameterByName('term'))) }))),
        
        any<Action<Map<number, AsyncState<SimpelPageMap<string, WordPress.BrochureResponse>>>>>()(
          s0.state.brochures.keySeq().map(k => 
            async<SimpelPageMap<string, WordPress.BrochureResponse>>()(s0.state.brochures.get(k)).map(a => (s: Map<number, AsyncState<SimpelPageMap<string, WordPress.BrochureResponse>>>) => s.set(k, a(s.get(k))))
            )
            .toArray()
        ).map(a => s1 => {
          let newData = a(s1.brochures)
          let first_entry = newData.get(1)
          return ({
            ...s1, 
            brochures: newData, 
            total_pages: first_entry != null && first_entry.kind == 'loaded' ? some(first_entry.value.total_pages) : none(), 
            current_page: first_entry != null && first_entry.kind == 'loaded' ? s1.current_page + 1 : s1.current_page
          })
        }),

        async<WordPress.TaxonomyResponse[]>()(s0.state.terms).map(a => s1 => ({ ...s1, terms: a(s1.terms) })),

        fromJSX(setState => {
            let isLoading = s0.state.total_pages.v.kind == 'l' || s0.state.brochures.count() < s0.state.total_pages.v.v

            if (s0.state.step == "step 1 - catalog") {
              return (
                <div className="brs__step step step--order">
                  {!s0.isDownload && (
                    <BrochuresWebshopLayout.ShoppingCart
                      s0={s0.state}
                      onPropChange={(key, value) => setState(setBrochureWebShopState(key, value))}
                    />
                  )}
                  <div className="brs__content">
                    <BrochuresWebshopLayout.ShoppingHeader shopTitle={s0.title} shopdescription={s0.description} />
                    <BrochuresWebshopLayout.StepOne
                      isLoading={isLoading}
                      isDownload={s0.isDownload}
                      s0={s0.state}
                      onPropChange={(key, value) => setState(setBrochureWebShopState(key, value))}
                    />
                  </div>
                </div>
              )
            }

            if (s0.state.step == "step - 2 - form") {
              return (
                <div className="brs__step step step--info">
                  <BrochuresWebshopLayout.ShoppingCart
                    s0={s0.state}
                    onPropChange={(key, value) => setState(setBrochureWebShopState(key, value))}
                  />
                  <div className="brs__content">
                    <BrochuresWebshopLayout.StepTwo
                      s0={s0.state}
                      onPropChange={(key, value) => setState(setBrochureWebShopState(key, value))}
                    />
                  </div>
                </div>
              )
            }

            return null
        })
    ])
  ) 
}


